module.exports = __webpack_public_path__ + "static/Githyanki-efdb23970d9f7649da0f1ed341855324.jpg";